import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomePersonalFeed: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHomePersonalFeed"><Path d="M14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12Z" stroke="currentColor"/><Path d="M16.5 20.5C16.5 18.0147 14.4853 16 12 16C9.51472 16 7.5 18.0147 7.5 20.5" stroke="currentColor"/><Path d="M3.5 9V20.5H20.5V9L12 3.5L3.5 9Z" stroke="currentColor" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconHomePersonalFeed;
